// Generated by CoffeeScript 2.7.0
var DISCRIPTION, DISPLAY_OPTIONS, SettingsOthers;

import SettingsContainer from 'trunks/vue/admin/components/settings/settings_container.js';

import TransformUserModal from 'trunks/vue/admin/components/settings/settings_others/transform_user_modal.js';

import UpdateUsersModal from 'trunks/vue/admin/components/settings/settings_others/update_users_modal.js';

import ImportOrganizationsAndUsersModal from 'trunks/vue/admin/components/settings/settings_others/import_organizations_and_users_modal.js';

DISPLAY_OPTIONS = {
  categories_public: "公开文章",
  verify_with_name: "验证姓名",
  verify_with_phone: "验证手机号",
  profile_required: "完善资料",
  namecard_enable: "显示名片",
  comment_enable: "评论",
  enable_contact: "通讯录",
  third_preview_attachment: "第三方附件预览",
  push_wechat_message: "微信消息推送",
  table_mapper: {
    form: "表单数据库映射",
    yet_another_workflow_flow: "流程数据库映射"
  }
};

DISCRIPTION = {
  profile_required: '（提示用户完善资料（手机号...））',
  namecard_enable: '（开启后微信推送时将展示用户的头像，可在名片模版处修改名片）',
  comment_enable: '（开启后，文章、普通通知、模版通知和表单可以评论）'
};

export default SettingsOthers = Vue.extend({
  components: {
    'settings-container': SettingsContainer
  },
  props: {
    activeTab: {
      type: String
    },
    othersOptions: {
      type: Object
    }
  },
  data: function() {
    return {
      settingsOthersOptions: this._generateOthersOptions()
    };
  },
  template: `<settings-container :activeTab="activeTab">
  <template slot="content">
    <div class="content-head">
      <button class="text-btn btn-primary" @click="openUpdateUsersModal">
        <i class="slp-refresh"></i>
        <span>批量更新用户</span>
      </button>
      <button class="text-btn btn-primary" @click="openTransferUserModal">
        <i class="slp-half-arrow-h"></i>
        <span>转移用户</span>
      </button>
      <button class="text-btn btn-primary" @click="openImportOrganizationsAndUsersModal">
        <i class="slp-download-o"></i>
        <span>导入成员和组织关系</span>
      </button>
    </div>
    <div class="content-body">
      <template v-for="option in settingsOthersOptions">
        <div class="field">
          <div class="field-head">
            <div class="field-title">{{ option.name }}</div>
          </div>
          <div class="field-input">
            <label class="switch">
              <input type="checkbox"
                     v-model="option.value">
              <span></span>
            </label>
            <div class="description helper-text">{{ option.description }}</div>
          </div>
        </div>
      </template>
    </div>
    <div class="content-footer">
      <button class="content-footer-btn"
              @click="updateSettings">更新</button>
    </div>
  </template>
</settings-container>`,
  methods: {
    openTransferUserModal: function() {
      return new TransformUserModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('transform-user-modal-container')
      });
    },
    openUpdateUsersModal: function() {
      return new UpdateUsersModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('update-users-modal-container')
      });
    },
    openImportOrganizationsAndUsersModal: function() {
      return new ImportOrganizationsAndUsersModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('import-organizations-and-users-container')
      });
    },
    updateSettings: function() {
      var data;
      data = {
        namespace: {
          table_mapper: {}
        }
      };
      _.each(this.settingsOthersOptions, function(option) {
        if (option.key.indexOf('__') > -1) {
          return data.namespace.table_mapper[option.key.split('__')[1]] = option.value;
        } else {
          return data.namespace[option.key] = option.value;
        }
      });
      return Skylark.Libs.Ajax.patch('/admin/settings/others.json', {
        data: data,
        responseType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: function() {
          return Skylark.Bridge.newAlertify('更新成功', {
            type: 'success'
          });
        },
        error: function() {
          return Skylark.Bridge.newAlertify('更新失败', {
            type: 'error'
          });
        }
      });
    },
    _generateOthersOptions: function() {
      var options, settingsOthersOptions;
      options = _.omit(DISPLAY_OPTIONS, 'table_mapper');
      settingsOthersOptions = _.map(options, (option, key) => {
        return {
          key: key,
          value: this.othersOptions[key],
          name: option,
          description: DISCRIPTION[key] || ''
        };
      });
      _.each(DISPLAY_OPTIONS.table_mapper, (option, key) => {
        var item;
        item = {
          key: `table_mapper__${key}`,
          value: this.othersOptions["table_mapper"][key],
          name: option,
          description: ''
        };
        return settingsOthersOptions.push(item);
      });
      return settingsOthersOptions;
    }
  }
});
